import React from "react";
import PublicSeoHub from "./PublicSeoHub";

export default function GlossaryHub() {
  return <PublicSeoHub type="glossary" />;
}